import { StudentRegistration } from '@schooly/api';
import { useMemo } from 'react';

import { isRejectedEnrollment } from './utils';

export const useFilteredRegistrations = (registrations: StudentRegistration[]) => {
  return useMemo(() => {
    const [rejectedRegistrations, activeRegistrations] = registrations.reduce<
      [StudentRegistration[], StudentRegistration[]]
    >(
      (acc, registration) => {
        if (isRejectedEnrollment(registration)) acc[0].push(registration);
        else acc[1].push(registration);
        return acc;
      },
      [[], []],
    );

    return { activeRegistrations, rejectedRegistrations, registrations };
  }, [registrations]);
};
